import React from "react";
import { Modal, ModalBody } from "react-bootstrap";
import Lottie from "lottie-react";
import styles from "./tg-main-loader.module.scss";
import useScreenSize from "../../utils/hook/useScreenSize";
import loaderLottie from "../../../public/osci/json/loaderLottie.json";
const TGMainLoader = _ref => {
  let {
    isLoading = true,
    isGlobal = true,
    customClassName = ""
  } = _ref;
  const isDesktopView = useScreenSize()?.deviceSize?.width > 767;
  if (isLoading) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
      show: true,
      centered: true,
      className: ` ${!isGlobal && customClassName !== "" ? customClassName : ""} ${styles["loader-container"]} ${isGlobal && "main-loading-spinner"}`,
      backdropClassName: `${!isGlobal && customClassName !== "" ? customClassName : ""} ${styles["loader-backdrop"]} ${isGlobal && "main-loading-spinner"}`,
      "aria-label": "dialog box"
    }, /*#__PURE__*/React.createElement(ModalBody, {
      style: {
        width: "max-content",
        margin: "auto",
        background: "unset",
        border: "unset",
        padding: "unset"
      }
    }, /*#__PURE__*/React.createElement(Lottie, {
      animationData: loaderLottie,
      loop: true,
      style: {
        height: "250px",
        width: "250px"
      }
    }), /*#__PURE__*/React.createElement("br", null))));
  }
};
export default TGMainLoader;